/**
 * The hidden placeholder club that holds athletes/parents who registered on the
 * public site without a real club. Mirrors backend/src/lib/individualClub.ts —
 * keep the id in sync. Used to give club-less "individual" accounts a friendlier
 * UI (no team/sport shown as "-", no club leaderboard tab, etc.).
 */
export const INDIVIDUAL_CLUB_ID = "00000000-0000-4000-8000-000000000001";

export function isIndividualClub(clubId?: string | null): boolean {
  return !!clubId && clubId === INDIVIDUAL_CLUB_ID;
}

/**
 * True when a parent's child does NOT belong to a real club — either the hidden
 * individual-athletes placeholder club, or no club at all. Such a child has no
 * team, trainings, attendance, events or coach-recorded metrics, so the parent
 * UI switches to a learning-first layout for them.
 */
export function isIndividualChild(
  child?: { athlete?: { athlete_profiles?: { club?: { id: string } | null } | null } } | null,
): boolean {
  const club = child?.athlete?.athlete_profiles?.club;
  return !club || isIndividualClub(club.id);
}
